module.exports = __webpack_public_path__ + "img/domain_qxyl.6fddfa65.gif";